"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetChangeOverTime = void 0;
var React = require("react");
var ApWidgetTrendArrow_1 = require("../ApWidgetTrendArrow");
var styles_1 = require("./styles");
exports.ApWidgetChangeOverTime = function (_a) {
    var label = _a.label, value = _a.value, trend = _a.trend, isNoCriteria = _a.isNoCriteria, isUpTrendNegative = _a.isUpTrendNegative, props = __rest(_a, ["label", "value", "trend", "isNoCriteria", "isUpTrendNegative"]);
    var compare = value || '—';
    return (React.createElement(styles_1.Wrapper, __assign({}, props),
        React.createElement(styles_1.Trend, null,
            label && React.createElement(styles_1.TrendLabel, null, label),
            React.createElement(styles_1.TrendValue, null,
                React.createElement(ApWidgetTrendArrow_1.ApWidgetTrendArrow, { trend: trend, negative: isUpTrendNegative, isNoCriteria: isNoCriteria }),
                compare))));
};
//# sourceMappingURL=ApWidgetChangeOverTime.js.map